import { useQuery } from '@tanstack/react-query';
import { API_PATHS } from 'api';
import { getLead } from 'api/leads';
import { LeadApiResponse } from 'models/Lead';
import { queryClient } from 'react-query';

const fetchLead = async (
  id: string,
  isPersonal = false,
): Promise<LeadApiResponse> => {
  const path = isPersonal
    ? API_PATHS.personalLeads.getLeadById(id)
    : getLead(id);
  return queryClient.fetchQuery<LeadApiResponse>({
    queryKey: [path, { id }],
  });
};

const useLead = (id: string, isPersonal = false) => {
  return useQuery({
    queryKey: [`${isPersonal ? 'personal-' : ''}lead`, { id }],
    queryFn: () => fetchLead(id, isPersonal),
    enabled: !!id,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useLead;
